import { render } from "./BatchProcessing.vue?vue&type=template&id=ef4ac116&scoped=true"
import script from "./BatchProcessing.js?vue&type=script&lang=js&external"
export * from "./BatchProcessing.js?vue&type=script&lang=js&external"

import "./BatchProcessing.vue?vue&type=style&index=0&id=ef4ac116&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef4ac116"]])

export default __exports__